/**
 * SpecialistDot — a named specialist's colour dot, optionally with the name. The colour comes from
 * the Specialist record (config/specialists.yaml), so this component knows no specialist ids.
 */

import './AgentLayout.css';

export default function SpecialistDot({ specialist = null, showName = false, size = 8, className = '' }) {
  const colour = specialist?.colour || 'var(--text-faint)';
  const name = specialist?.name || specialist?.id || 'Agent';
  return (
    <span className={`agent-sdot ${className}`.trim()} title={specialist?.title ? `${name}, ${specialist.title}` : name}>
      <span className="agent-sdot__dot" style={{ background: colour, width: size, height: size }} aria-hidden="true" />
      {showName && <span className="agent-sdot__name">{name}</span>}
    </span>
  );
}
